import React from 'react';
import styled, { css } from 'styled-components';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';

import { ShopOutlined, AppstoreOutlined } from '@ant-design/icons';

import Types from '../../modules/types';

const {
  STORE_PRODUCT_TYPE_LABELS_MAP,
} = Types;

export const columnNameAdmin = {
  path: 'name',
  title: 'Name',
  link: '/products/:_id',
};

export const columnNameSeller = {
  path: 'name',
  title: 'Name',
  link: '/store/products/:_id',
};

export const columnType = {
  path: 'type',
  render: record => (
    record.kind !== 'TANGIBLE'
    ? Types.PRODUCT_KIND_LABELS_MAP[record.kind]
    : `${STORE_PRODUCT_TYPE_LABELS_MAP[record.type]}`
  ),
};

const StockWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
`;

const StockStorageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  width: 40px;
  height: 100%;
  gap: 5px;
`;

const StockStoragePart = styled.div`
  height: 100%;
  ${({ $outOfStock }) => $outOfStock && css`
    opacity: 0.3;
  `}
`;

const ColumnCollectionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  white-space: nowrap;
`;

const ColumnCollectionsSeparator = styled.div`
  padding: 0px 5px 0 1px;
`;

export const columnStock = {
  path: 'stock',
  align: 'right',
  render: (record, column, props) => (
    <StockWrapper>
      {
        (
            Types.PRODUCT_KIND_ABSTRACT.includes(record.kind)
          ? [Infinity]
          : props.viewer?.role === 'ADMIN'
          ? Types.SHIPPING_STORAGE_TANGIBLE
          : (
                props.viewer?.storeType === 'MERCHANT'
              ? (
                    props.viewer?.storeData?.storageOptions?.length
                  ? props.viewer.storeData.storageOptions
                  : [null]
                )
              : props.viewer?.storeType === 'RESELLER'
              ? ['WAREHOUSE']
              : [null]
            )
        )
        .map(storage => (
          storage === Infinity
          ? '∞'
          : !storage
          ? '-'
          : (
            <StockStorageWrapper
              key={storage}
            >
              <StockStoragePart
                $outOfStock={record.stockAggregates?.[storage] === 0}
              >
                {
                    record.stockAggregates
                  ? (record.stockAggregates[storage] || 0)
                  : '-'
                }
              </StockStoragePart>
              <StockStoragePart>
                {
                    storage === 'WAREHOUSE'
                  ? (
                      <AppstoreOutlined
                        title={Types.SHIPPING_STORAGE_LABELS_MAP[storage]}
                      />
                    )
                  : storage === 'LOCAL'
                  ? (
                      <ShopOutlined
                        title={Types.SHIPPING_STORAGE_LABELS_MAP[storage]}
                      />
                    )
                  : null
                }
              </StockStoragePart>
            </StockStorageWrapper>
          )
        ))
      }
    </StockWrapper>
  ),
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  link: '/stores/:store._id',
};

export const columnCategoryAdmin = {
  title: 'Category',
  path: 'category.name',
  link: '/categories/:category._id',
};

export const columnCategorySeller = {
  title: 'Category',
  path: 'category.name',
  link: '/store/categories/:category._id',
};

export const columnCollectionAdmin = {
  title: 'Collection',
  path: 'collections',
  link: '/collections/:collection._id',
  render: (record) => (
    record.collections.length
    ? (
        <ColumnCollectionsWrapper>
          {
            record.collections.reduce(
              (agr, collection, i, array) => {
                agr.push(
                  <Link
                    key={collection._id}
                    to={`/collections/${collection._id}`}
                  >
                    {`${collection.name}`}
                  </Link>
                );
                if ((array.length - 1) > i) {
                  agr.push(
                    <ColumnCollectionsSeparator
                      key={`${collection._id}@@@separator`}
                    >
                      ,
                    </ColumnCollectionsSeparator>
                  );
                }
                return agr;
              },
              [],
            )
          }
        </ColumnCollectionsWrapper>
      )
    : '-'
  ),
};

export const columnCollectionSeller = {
  title: 'Collection',
  path: 'collections',
  link: '/store/collections/:collection._id',
  render: (record) => (
    record.collections.length
    ? (
        <ColumnCollectionsWrapper>
          {
            record.collections.reduce(
              (agr, collection, i, array) => {
                agr.push(
                  <Link
                    key={collection._id}
                    to={`/collections/${collection._id}`}
                  >
                    {`${collection.name}`}
                  </Link>
                );
                if ((array.length - 1) > i) {
                  agr.push(
                    <ColumnCollectionsSeparator
                      key={`${collection._id}@@@separator`}
                    >
                      ,
                    </ColumnCollectionsSeparator>
                  );
                }
                return agr;
              },
              [],
            )
          }
        </ColumnCollectionsWrapper>
      )
    : '-'
  ),
};

export const columnPublishedAt = {
  path: 'publishedAt',
  name: 'Published At',
  render: record => (
    moment(record.publishedAt).format('DD.MM.YYYY. HH:mm')
  ),
};

export const ADMIN = [
  columnNameAdmin,
  columnStock,
  columnType,
  columnStore,
  columnCategoryAdmin,
  columnCollectionAdmin,
  columnPublishedAt,
];

export const SELLER = [
  columnNameSeller,
  columnStock,
  columnCategorySeller,
  columnCollectionSeller,
  columnPublishedAt,
];
